<template>
  <div class="card mb-25 border-0 radius-7 bg-white">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-md-25 d-sm-flex align-items-center justify-content-between"
      >
        <h5 class="card-title fw-bold mb-0">Logs</h5>
        <div class="card-buttons">
          <a
            href="javascript:void(0);"
            class="card-btn mt-10 mt-sm-0 d-inline-block fw-medium text-decoration-none transition ps-10 pe-10 pt-5 pb-5 active"
          >
            Uploads em tempo real
          </a>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Data
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Nome original
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Nome de conversão
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Duração
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Tamanho do arquivo
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, key) in getRealtime" :key="key">
              <td class="shadow-none lh-1 text-black-emphasis">
                {{ item.datetime }}
              </td>
              <td class="shadow-none lh-1 fw-bold text-black-emphasis">
                {{ item.data.originalName }}
              </td>
              <td class="shadow-none lh-1 text-black-emphasis">
                <span v-if="item.data.file != null">
                  {{ item.data.file }}
                </span>

                <span v-else class="badge text-bg-danger fs-13 radius-7">Arquivo corrompido</span>

              </td>
              <td class="shadow-none lh-1 text-black-emphasis">
                {{ item.data.duration }}
              </td>
              <td class="shadow-none lh-1 text-black-emphasis">
                {{ item.data.size }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';

export default defineComponent({
  name: "RealtimeTable",
  data() {
    return {};
  },
  computed:{
    ...mapGetters([
      'getRealtime'
    ])
  },
  methods: {
    ...mapActions([
        "setLastLogsRealtime"
    ]),
  },
  created() {
    this.setLastLogsRealtime();
  }
});
</script>